import SchemeVillage from "../components/configuration/SchemeVillage/SchemeVillage";

const SchemeVillagePage = () => {
  return (
    <SchemeVillage/>
  );
};  

export default SchemeVillagePage;
